
import {Component, Prop, Vue} from "vue-property-decorator";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";

@Component({
  components: {
    FontAwesomeIcon
  }
})
export default class StatusInput extends Vue {
  @Prop({})
  public selected!: boolean;

  @Prop({})
  protected properties!: { html: {}, assignments?: object, options?: object };

  //local variables
  protected html: object = {};
  public icon: string[] = [];

}
